module.exports = __webpack_public_path__ + "static/img/icon-img1.bb81a05.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/icon-img1.png
// module id = YYFK
// module chunks = 1